/* eslint-disable lines-between-class-members */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createApp } from 'vue'
import businessTheme from '@xhs/yam-beer/theme/businessTheme'
import ToastManager, { ToastSettings, ToastType } from './ToasterManager'

const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined'

export class Toaster {
  container?: HTMLElement

  toastManager?: any
  defaultSettings: any

  constructor(defaultSettings: ToastSettings) {
    if (!isBrowser) {
      return
    }

    this.container = document.createElement('div')
    this.defaultSettings = defaultSettings || {}

    document.body.appendChild(this.container)
  }

  createManager(theme = businessTheme) {
    // eslint-disable-next-line
    if (this.toastManager && !this.toastManager._.isUnmounted) {
      return this.toastManager
    }
    const app = createApp(
      ToastManager, {
        theme,
      },
    )
    if (this.container) {
      this.toastManager = app.mount(this.container)
    }
    return this.toastManager
  }

  closeAll() {
    if (!this.toastManager) {
      this.createManager()
    }
    this.toastManager.toasts.forEach((toast: ToastType) => {
      toast.close()
    })
  }

  notify(title: string, settings: ToastSettings = {}) {
    if (!this.toastManager) {
      this.createManager()
    }
    return this.toastManager.notify(title, {
      ...this.defaultSettings,
      ...settings,
      modifier: 'info',
    })
  }

  success(title: string, settings: ToastSettings = {}) {
    if (!this.toastManager) {
      this.createManager()
    }
    return this.toastManager.notify(title, {
      ...this.defaultSettings,
      ...settings,
      modifier: 'success',
    })
  }

  warning(title: string, settings: ToastSettings = {}) {
    if (!this.toastManager) {
      this.createManager()
    }
    return this.toastManager.notify(title, {
      ...this.defaultSettings,
      ...settings,
      modifier: 'warn',
    })
  }

  danger(title: string, settings: ToastSettings = {}) {
    if (!this.toastManager) {
      this.createManager()
    }
    return this.toastManager.notify(title, {
      ...this.defaultSettings,
      ...settings,
      modifier: 'error',
    })
  }
}

export const toaster = new Toaster({
})
export default toaster
